




























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import OutlinedButton from '@/components/molecules/OutlinedButton/OutlinedButton.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import { copyToClipboard } from '@/utils';

@Component({
  components: {
    OutlinedButton,
    FilledButton,
    Typography
  }
})
export default class ToastConnectToolTip extends Vue {
  @Prop({ default: 'toast' }) providerName!: string;
  isLoading = false;

  get tPrefix() {
    return 'common.components.businessProvider';
  }

  get business() {
    const businessInfo = this.$store.getters['business/getBusinessState'];

    return businessInfo || {};
  }

  get locations() {
    const businessInfo = this.$store.getters['business/getBusinessState'];

    if (businessInfo && businessInfo.businessLocations) {
      return businessInfo.businessLocations.map((location: any) => {
        return {
          id: location.id,
          address: location.address || 'Unknown Address',
          city: location.city || 'Unknown City',
          state: location.state || 'Unknown State'
        };
      });
    }

    return [];
  }

  cancel() {
    this.$emit('cancel');
  }

  copyLocationId(id: string) {
    copyToClipboard(id, () => {
      this.$notification('Copied to clipboard!', 'success');
    });
  }

  async confirm() {
    this.isLoading = true;
    this.$ga.event({
      eventCategory: 'integrations',
      eventAction: 'click-confirm',
      eventLabel: String(
        this.$t(`${this.tPrefix}.providerApiTokenModalTitle`, {
          provider: this.providerName
        })
      )
    });

    this.$emit('confirm', {
      onSuccess: () => {
        this.isLoading = false;
      }
    });
  }
}
